<template>
  <div>
    <div class="gallery d-flex justify-content-between" :class="custom_class">
      <a
        :href="item.src"
        class="glightboxTest"
        v-for="(item, i) in items"
        :key="i"
        :style="{ width: itemsW, height: itemsH, margin: itemsMargin }"
      >
        <ImageBox :item="item" />
      </a>
    </div>
  </div>
</template>

<script>
import ImageBox from '@/components/media/ImageBox.vue';

export default {
  name: 'Gallery',

  props: {
    custom_class: String,
    items: Array,
    itemsW: String,
    itemsH: String,
    itemsMargin: String,
  },

  components: {
    ImageBox,
  },

  // filters: {
  //   resolveSrc: function (value, obj) {
  //     if( value.indexOf('https://') !== -1 ){
  //       return value;
  //     }else{
  //       return obj.isVideo ? require(`@/assets/videos/${obj.src}`) : require(`@/assets/images/${obj.src}`);
  //     }
  //   }
  // },

  mounted() {
    let lightboxDescription = this.$GLightbox({
      selector: 'glightboxTest',
      openEffect: 'none',
      closeEffect: 'none',
    });
  },
};
</script>

<style scoped lang="scss">
.gallery {
  @include media-breakpoint-down(md) {
    &.h-scroll-down-md {
      overflow: auto;
      a {
        min-width: 60%;
        flex-shrink: 0;
      }
    }
  }
}
</style>
